const BASE = process.env.REACT_APP_BACKEND_URL;

async function parseJsonOrThrow(resp, fallbackMessage) {
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || fallbackMessage);
  }
  return resp.json();
}

export async function listQuestions({ themeName, organizationId, sessionId, token }) {
  const resp = await fetch(`${BASE}/listQuestions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ themename: themeName, organizationId, sessionId }),
  });
  const data = await parseJsonOrThrow(resp, "Failed to load questions");
  return data.questions || [];
}

/**
 * Add or edit one question. `file` is an optional File object for the hint image.
 * `removeHint`/`keepExistingImage` mirror old/admin/add-question-upload.php's flags.
 */
export async function saveQuestion({
  themeName,
  organizationId,
  sessionId,
  token,
  action,
  editId,
  question,
  file,
  removeHint,
  keepExistingImage,
}) {
  const formData = new FormData();
  formData.append("themename", themeName);
  formData.append("action", action);
  if (editId) formData.append("edit_id", editId);
  formData.append("question_name", question.question_name);
  formData.append("option_one", question.option_one);
  formData.append("option_two", question.option_two);
  formData.append("option_three", question.option_three);
  formData.append("option_four", question.option_four);
  formData.append("option_five", question.option_five);
  formData.append("option_six", question.option_six);
  formData.append("correct_answer", question.correct_answer);
  formData.append("showOption", question.showOption);
  if (file) formData.append("file0", file);
  if (removeHint) formData.append("removeHint", "true");
  if (keepExistingImage) formData.append("keepExistingImage", "true");

  const resp = await fetch(`${BASE}/saveQuestion`, {
    method: "POST",
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });
  return parseJsonOrThrow(resp, "Failed to save question");
}

export async function deleteQuestion({ themeName, id, token }) {
  const resp = await fetch(`${BASE}/deleteQuestion`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ themename: themeName, id }),
  });
  return parseJsonOrThrow(resp, "Failed to delete question");
}

export async function deleteAllQuestions({ themeName, token }) {
  const resp = await fetch(`${BASE}/deleteAllQuestions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ themename: themeName }),
  });
  return parseJsonOrThrow(resp, "Failed to delete all questions");
}

export async function importQuestionsCsv({ themeName, rows, token }) {
  const resp = await fetch(`${BASE}/importQuestionsCsv`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ themename: themeName, rows }),
  });
  return parseJsonOrThrow(resp, "Failed to import CSV");
}
